import { render, staticRenderFns } from "./faultstatistic.vue?vue&type=template&id=3a65f7c4&scoped=true&"
import script from "./faultstatistic.vue?vue&type=script&lang=js&"
export * from "./faultstatistic.vue?vue&type=script&lang=js&"
import style0 from "./faultstatistic.vue?vue&type=style&index=0&id=3a65f7c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65f7c4",
  null
  
)

export default component.exports